<template>
  <div class="play_list">
    <div style="margin: 2vw 0; font-weight: 550; font-size: 3.8vmin;">播放列表( <span style="color: #fb7a9f">{{ count }}</span> )</div>
    <div class="number_list">
      <router-link :to="{ name: 'VideoPlay', query: { pid: vid, nid:i }}" v-for="i in count" :key="i">
        <div class="number_list_item" :class="{'active':isActive(i)}">
          <span>{{ i }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlayList",
  props:['count'],
  data(){
    return {
      vid:this.$route.query.pid,
    }
  },
  methods:{
    isActive(i){
      if (this.getNid == 0) {
        return (i-1) == this.getNid
      }
      return this.getNid == i;
    },
  },
  computed:{
    getNid(){
      return this.$route.query.nid||0
    }
  }
}
</script>

<style scoped lang="scss">
.play_list{
  background:#FFFFFF;
  padding: 0 3vw;

  .number_list{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
    overflow-x: auto;
    -ms-overflow-style: none;  /* IE 和 Edge */
    scrollbar-width: none;     /* Firefox */
    gap: 5vw;
    ::-webkit-scrollbar {
      display: none;             /* Chrome, Safari 和 Opera */
    }
    .active{
      background:#fb7a9f !important;
      span{
        color: #FFFFFF !important;
      }
    }
    .number_list_item{
      background: #f2f3f5;
      padding: 2vw;
      border-radius: 1.2vw;
      align-items: center;
      justify-content: center;
      display: flex;
      span{
        color: #212121;
      }
    }
  }
}
</style>
